"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var PaymentCartIcons = /** @class */ (function (_super) {
    __extends(PaymentCartIcons, _super);
    function PaymentCartIcons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildItems = function (methods, icons) {
            return methods.includes(",")
                ? methods.split(",").map(function (item, i) { return (React.createElement("li", { key: i, className: "mr-2 " + (_this.props.wrap ? "mb-3" : "") },
                    React.createElement(Snippets.Svg, { name: "payment-" + item, height: 17, className: "inline-block" }))); })
                : [];
        };
        return _this;
    }
    PaymentCartIcons.prototype.render = function () {
        var _a = this.props, methods = _a.methods, icons = _a.icons, footer = _a.footer, wrap = _a.wrap;
        if (footer) {
            return footer.payment_icons_enabled ? (React.createElement("ul", { className: "list-reset flex " + (wrap ? "align-center justify-center flex-wrap" : "") }, this.buildItems(methods, icons))) : null;
        }
        return React.createElement("ul", { className: "list-reset flex " + (wrap ? "align-center justify-center flex-wrap" : "") }, this.buildItems(methods, icons));
    };
    return PaymentCartIcons;
}(React.PureComponent));
exports.PaymentCartIcons = PaymentCartIcons;
